import React from "react";
import { getCardImage } from "../../resultVisuals/cardAssets";
import CardImg from "../../../../components/CardImg";

/**
 * Reference (allpanel9 admin, casino/queen) card dealing: the card string is dealt
 * round-robin to Total 0..3 (position 1..4 repeating); "1" = not dealt yet (the slot
 * still advances). Face value = first char, Q = 12. Total 1/2/3 get +1/+2/+3 once
 * they hold a card.
 */
function queenPlayersCards(cardString) {
  const cards = String(cardString || "").split(",").map((c) => c.trim());
  const groups = [[], [], [], []];
  const totals = [0, 0, 0, 0];
  let slot = 0;
  cards.forEach((token) => {
    if (token !== "1" && token !== "") {
      groups[slot].push(token);
      const first = token.charAt(0);
      if (first === "Q") totals[slot] += 12;
      else if (parseInt(first, 10) !== 1 && !Number.isNaN(parseInt(first, 10))) totals[slot] += parseInt(first, 10);
    }
    slot = (slot + 1) % 4;
  });
  for (let i = 1; i < 4; i++) if (totals[i] > 0) totals[i] += i;
  return { groups, totals };
}

/**
 * Queen card overlay — reference markup:
 * .casino-video-cards[.hide-cards] > .casino-cards-shuffle + .casino-video-cards-container
 *   > 4 × div > (.dealer-name.w-100.mb-1 > span[.text-success] "Total N:" + span.text-warning.ml-1 total)
 *             + div > span > img (one per dealt card)
 * Styled by the ported reference rules (.casino-queen .casino-video-cards … in index.css).
 * `subData` = the queen markets (sub, ordered by sr) — their `nat` is the label.
 */
export default function QueenCardsOverlay({ normalizedResultData, subData = [], showCards = true, onToggle }) {
  const cardString = String(normalizedResultData ?? "");
  if (!cardString) return null;
  const firstCard = cardString.split(",")[0].trim();
  const { groups, totals } = queenPlayersCards(cardString);
  const hidden = !showCards || firstCard === "1";

  return (
    <div className={`casino-video-cards${hidden ? " hide-cards" : ""}`}>
      <div className="casino-cards-shuffle" onClick={() => firstCard !== "1" && onToggle && onToggle()}>
        <i className="fas fa-grip-lines-vertical" />
      </div>{" "}
      <div className="casino-video-cards-container">
        {groups.map((cards, i) => {
          // Reference: a total is highlighted when it is >= every other total
          const isLeader = totals.every((t) => totals[i] >= t);
          return (
            <React.Fragment key={i}>
              {i > 0 && " "}
              <div>
                <div className="dealer-name w-100 mb-1">
                  <span className={isLeader ? "text-success" : ""}>{`${subData[i]?.nat ?? `Total ${i}`}: `}</span>{" "}
                  <span className="text-warning ml-1">{totals[i]}</span>
                </div>{" "}
                <div>
                  {cards.map((token, ci) => (
                    <span key={ci}>
                      <CardImg src={getCardImage(token)} />
                    </span>
                  ))}
                </div>
              </div>
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
}
